<!--
  ~ Copyright 2022-2026 NXGN Management, LLC. All Rights Reserved.
  -->
<div class="table-block">
  <div class="recordRow">
    <div class="recordLabel">Merchant Name</div>
    <div id="merchantName" class="recordValue">
      {{ merchant.merchantName }}
    </div>
  </div>

  <div class="recordRow" *ngIf="!isInstaMedOrGlobalPayments()">
    <div class="recordLabel">Doing Business as</div>
    <div id="doingBusinessAs" class="recordValue">
      {{ merchant.doingBusinessAs }}
    </div>
  </div>

  <div class="recordRow" *ngIf="!isInstaMedOrGlobalPayments()">
    <div class="recordLabel">Also Known as</div>
    <div id="alsoKnownAsName" class="recordValue">
      {{ merchant.alsoKnownAsName }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">SiteGen Practice ID</div>
    <div id="practiceID" class="recordValue">
      {{ merchant.externalMerchantId }}
    </div>
  </div>

  <div class="recordRow">
    <div class="recordLabel">SAP ID</div>
    <div id="customerAccountNumber" class="recordValue">
      {{ merchant.customerAccountNumber }}
    </div>
  </div>

  <ng-container
    *ngIf="
      merchant.merchantMigrationDetails &&
      merchant?.id !== merchant?.merchantMigrationDetails?.previousMmid &&
      merchantService.isInstaMed(merchant)
    "
  >
    <div
      class="recordRow"
      *ngIf="merchant.merchantMigrationDetails?.toBeMigrated"
    >
      <div class="recordLabel">Previous MMID (Internal)</div>
      <div id="previousMMID" class="recordValue">
        {{ merchant.merchantMigrationDetails?.previousMmid }}
      </div>
    </div>

    <div
      class="recordRow"
      *ngIf="merchant.merchantMigrationDetails?.toBeMigrated"
    >
      <div class="recordLabel">Previous Merchant Name</div>
      <div class="recordValue">
        {{ merchant.merchantMigrationDetails?.previousMerchantName }}
      </div>
    </div>

    <div
      class="recordRow"
      *ngIf="merchant.merchantMigrationDetails?.toBeMigrated"
    >
      <div class="recordLabel">Previous Processor</div>
      <div id="previousProcessor" class="recordValue">
        {{ merchant.merchantMigrationDetails?.previousProcessor }}
      </div>
    </div>

    <div
      class="recordRow"
      *ngIf="
        merchant.merchantMigrationDetails?.toBeMigrated &&
        merchant.merchantMigrationDetails?.effectiveDate !== null
      "
    >
      <div class="recordLabel">Token Conversion Date</div>
      <div class="recordValue">
        {{ merchantConversionDate }}
      </div>
    </div>

    <div
      class="recordRow"
      *ngIf="merchant.merchantMigrationDetails?.toBeMigrated"
    >
      <div class="recordLabel">Status</div>
      <div class="recordValue">
        {{ merchant.merchantMigrationDetails?.migrationStatus }}
      </div>
    </div>
  </ng-container>

  <div class="recordRow" *ngIf="!isInstaMedOrGlobalPayments()">
    <div class="recordLabel">Phone Number</div>
    <div id="merchantPhone" class="recordValue">
      {{ merchant.phoneNumber }}
    </div>
  </div>

  <div class="recordRow" *ngIf="!isInstaMedOrGlobalPayments()">
    <div class="recordLabel">Transaction Limit</div>
    <div id="txLimit" class="recordValue">
      {{ merchant.maxTransactionLimit / 100 | currency }}
    </div>
  </div>
  <div class="recordRow" *ngIf="this.merchantService.isWorldPay(this.merchant)">
    <div class="recordLabel">Billing Descriptor</div>
    <div id="billingDescriptor" class="recordValue">
      {{ merchant.accountDetails.worldPayAccountDetails.billingDescriptor }}
    </div>
  </div>
  <div class="recordRow" *ngIf="this.merchantService.isWorldPay(this.merchant)">
    <div class="recordLabel">Ownership Type</div>
    <div id="ownershipType" class="recordValue">
      {{ merchant.accountDetails.worldPayAccountDetails.ownershipType }}
    </div>
  </div>
  <div class="recordRow" *ngIf="this.merchantService.isWorldPay(this.merchant)">
    <div class="recordLabel">Business Type</div>
    <div id="businessType" class="recordValue">
      {{ merchant.accountDetails.worldPayAccountDetails.businessType }}
    </div>
  </div>
  <div class="recordRow" *ngIf="this.merchantService.isWorldPay(this.merchant)">
    <div class="recordLabel">Website URL</div>
    <div id="websiteURL" class="recordValue">
      {{ merchant.accountDetails.worldPayAccountDetails.websiteURL }}
    </div>
  </div>
  <div class="recordRow" *ngIf="this.merchantService.isWorldPay(this.merchant)">
    <div class="recordLabel">SIC/MCC Code</div>
    <div id="sicMccCode" class="recordValue">
      {{
        MCC_CODE[merchant.accountDetails.worldPayAccountDetails.mccCode].label
      }}
    </div>
  </div>
  <div class="recordRow" *ngIf="this.merchantService.isWorldPay(this.merchant)">
    <div class="recordLabel">Pay API Customer</div>
    <div id="payApiCustomer" class="recordValue">
      {{ merchant.payAPICustomer?.customerName }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.siteId">
    <div class="recordLabel">Site Id</div>
    <div id="siteId" class="recordValue">
      {{ merchant.siteId }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.siteId">
    <div class="recordLabel">Enterprise Id</div>
    <div id="enterpriseId" class="recordValue">
      {{ merchant.enterpriseId }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.siteId">
    <div class="recordLabel">Practice Id</div>
    <div id="practiceId" class="recordValue">
      {{ merchant.practiceId }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.practiceName">
    <div class="recordLabel">Practice Name</div>
    <div id="practiceName" class="recordValue">
      {{ merchant.practiceName }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.siteId">
    <div class="recordLabel">Client Name</div>
    <div id="clientName" class="recordValue">
      {{ merchant.clientName }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.siteId">
    <div class="recordLabel">GCN</div>
    <div id="gcn" class="recordValue">
      {{ merchant.gcn }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.locationName">
    <div class="recordLabel">Location Name</div>
    <div id="locationName" class="recordValue">
      {{ merchant.locationName }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.locationName">
    <div class="recordLabel">Location Alias</div>
    <div id="locationAlias" class="recordValue">
      {{ merchant.locationAlias }}
    </div>
  </div>
  <div class="recordRow" *ngIf="merchant.locationName">
    <div class="recordLabel">Location Id</div>
    <div id="locationId" class="recordValue">
      {{ merchant.locationId }}
    </div>
  </div>
  <div class="recordRow" *ngIf="isInstaMedOrGlobalPayments()">
    <div class="recordLabel">No Payments When $0 Balance Owed</div>
    <div id="suppressZeroBalancePayment" class="recordValue">
      {{ merchant.suppressZeroBalancePayment ? "Enabled" : "Disabled" }}
    </div>
  </div>
  <div class="recordRow" *ngIf="isInstaMedOrGlobalPayments()">
    <div class="recordLabel">ACH/eCheck</div>
    <div id="achEcheckEnabled" class="recordValue">
      {{ merchant.achEcheckEnabled !== false ? "Enabled" : "Disabled" }}
    </div>
  </div>
  <div class="recordRow" *ngIf="isInstaMedOrGlobalPayments()">
    <div class="recordLabel">AMEX</div>
    <div id="amexEnabled" class="recordValue">
      {{ merchant.amexEnabled ? "Enabled" : "Disabled" }}
    </div>
  </div>
  <div class="recordRow" *ngIf="isInstaMedOrGlobalPayments()">
    <div class="recordLabel">NGEPM Statement</div>
    <div id="suppressZeroBalancePayment" class="recordValue">
      {{ merchant?.ngepmStatement ? "Enabled" : "Disabled" }}
    </div>
  </div>
  <div class="recordRow" *ngIf="isInstaMedOrGlobalPayments()">
    <div class="recordLabel">Patient Balance Includes Bad Debt</div>
    <div id="balanceIncludesBadDebt" class="recordValue">
      {{ merchant?.balanceIncludesBadDebt ? "Enabled" : "Disabled" }}
    </div>
  </div>
  <div class="recordRow" *ngIf="isInstaMedOrGlobalPayments()">
    <div class="recordLabel">Direct Batching</div>
    <div id="directBatching" class="recordValue">
      {{ merchant?.directBatching ? "Enabled" : "Disabled" }}
    </div>
  </div>
</div>
